<div class="container size">
  <h2>Блюдо будет Вас ждать</h2>
  <div class="text">
    Мы напоминаем, что готовое блюдо будет подано к обозначенному времени. Если
    вы задержитесь, блюдо уже остынет.
  </div>
  <app-button theme="grey" (btnClick)="dismiss()">Хорошо</app-button>
</div>

<app-button-cross class="exit-btn" (click)="dismiss()"></app-button-cross>
